export default __webpack_public_path__ + "static/media/moss-on-wall1.fea2b6a4.jpg";